module.exports = __webpack_public_path__ + "img/trustpilot.114b9ffb.png";